import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Link as LinkS } from "react-scroll";
import { GoSearch } from "react-icons/go";
import { RiBookmark3Fill } from "react-icons/ri";
import { animateScroll as scroll } from "react-scroll";
import "./Navbar.scss";
import { useSelector } from "react-redux";
import logo from "../../images/showsdb-logo-white.png";

const Navbar = ({ toggleSidebar, isOpen, toggleSearchBox }) => {
  const watchlistCount = useSelector(
    (state) => state.watchlistMovie.watchlist.length
  );

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="nav-logo" onClick={toggleHome}>
          <img src={logo} alt="" className="logo-img" />
          <h1 className="logo-text">Showdex</h1>
        </Link>
        <ul className="nav-links">
          <li className="nav-item">
            <NavLink
              exact
              to="/new-movies"
              className="nav-link"
              activeClassName="nav-link active"
            >
              New Movies
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              // to="/"
              exact
              to="/trending-movies"
              className="nav-link"
              activeClassName="nav-link active"
            >
              Trending
            </NavLink>
          </li>
          <li className="nav-item">
            <LinkS
              to="coming-soon"
              className="nav-link"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
              offset={-20}
              activeClass="not-active"
            >
              Coming Soon
            </LinkS>
          </li>
          <li className="nav-item">
            <LinkS
              to="footer"
              className="nav-link"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
              // offset={-450}
              activeClass="active"
            >
              About
            </LinkS>
          </li>
        </ul>
        <div className="nav-utils">
          <Link className="bookmark-icon-div" to="/search">
            <GoSearch
              className="utils-icon search-icon"
              onClick={toggleSearchBox}
            />
          </Link>
          <Link className="bookmark-icon-div" to="/watchlist">
            <RiBookmark3Fill className="utils-icon" />
            {watchlistCount > 0 && (
              <span className="utils-icon-notification">{watchlistCount}</span>
            )}
          </Link>
          <div
            className={isOpen ? "nav-menu active" : "nav-menu"}
            onClick={toggleSidebar}
          >
            <div className="nav-menu_burger"></div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
